import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

export function usePreviousImprovementPlans({ processId, criterioId, unidad, sede, debounceMs = 0 }) {
  const { user } = useSelector((state) => state.auth);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const shouldFetch = Boolean(processId && criterioId && unidad);

  const url = useMemo(() => {
    if (!shouldFetch) return null;
    
    const params = new URLSearchParams();
    params.set('criterio', criterioId);
    params.set('unidad', unidad);
    if (sede) params.set('sede', sede);

    return `${process.env.REACT_APP_API_BASE_URL}reportes/procesos/${processId}/planes-mejora/previos?${params.toString()}`;
  }, [processId, criterioId, unidad, sede, shouldFetch]);

  useEffect(() => {
    if (!shouldFetch) {
      setLoading(false);
      setData([]);
      return;
    }

    const controller = new AbortController();
    const run = () => {
      setLoading(true);
      setError(null);

      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
        signal: controller.signal,
      })
        .then(async (res) => {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          const json = await res.json();
          setData(Array.isArray(json) ? json : []);
        })
        .catch((e) => {
          if (e.name !== 'AbortError') setError(e);
        })
        .finally(() => {
          if (!controller.signal.aborted) setLoading(false);
        });
    };

    let t;
    if (debounceMs > 0) {
      t = setTimeout(run, debounceMs);
    } else {
      run();
    }

    return () => {
      controller.abort();
      if (t) clearTimeout(t);
    };
  }, [url, shouldFetch, user?.token, debounceMs]);

  return { data, loading, error };
}
